import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=2953af4e&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=2953af4e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953af4e",
  null
  
)

export default component.exports